<template>
  <div class="section" id="user-comment">
    <div class="columns">
      <div class="column is-three-fifths-desktop is-offset-one-fifth-desktop">
        <h1 class="subtitle">コメントする</h1>
        <article class="media">
          <figure class="media-left">
            <p class="image is-64x64">
              <img src="https://bulma.io/images/placeholders/128x128.png">
            </p>
          </figure>
          <div class="media-content">
            <div class="field">
              <p class="control">
                <textarea class="textarea" placeholder="コメントを入力"></textarea>
              </p>
            </div>
            <div class="field">
              <p class="control has-text-centered">
                <button class="button is-primary">コメントする</button>
              </p>
            </div>
          </div>
        </article>

        <h2 class="heading">リスナーコメント</h2>
        <article class="media usercomment">
          <figure class="media-left">
            <p class="image is-64x64">
              <img src="https://bulma.io/images/placeholders/128x128.png">
            </p>
          </figure>
          <div class="media-content">
            <div class="content">
              <p>
                <strong>ユーザーニックネーム</strong>
                <br>
                コメントが入ります。コメントが入ります。コメントが入ります。コメントが入ります。コメントが入ります。
              </p>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserComment'
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/user-comment.scss';
</style>
